import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-147417be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
import { ref } from 'vue';
import addClinicShopDialog from './components/addClinicShopDialog';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getClinicShopList, delClinicShop } from '@/api/clinicShop.js';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const currentPage = ref(1);
    const total = ref(0);
    const pageSize = ref(8);

    // loading效果
    const loading = ref(false);

    /**
     * 获取广告组分页
     */
    const getData = async () => {
      loading.value = true;
      try {
        const res = await getClinicShopList({
          currentPage: currentPage.value,
          pageSize: 10
        });
        // console.log(res)
        tableData.value = res.records;
        total.value = res.total;
        currentPage.value = res.current;
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    getData();

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      currentPage.value = val;
      getData();
    };

    /** 新增飞书应用 */
    const addVisible = ref(false);
    const handleAddRow = () => {
      addVisible.value = true;
    };
    const current = ref(null);
    const handleUpdate = row => {
      current.value = row;
      handleAddRow();
    };
    const clearCurrent = () => {
      current.value = null;
    };
    const handleDel = row => {
      ElMessageBox.confirm('是否删除?', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delClinicShop({
          id: row.id
        });
        await getData();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['tenantShopAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "clinicId",
            label: "诊所id",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            prop: "clinicName",
            label: "门诊名称"
          }), _createVNode(_component_el_table_column, {
            prop: "path",
            label: "微信公众号路径"
          }), _createVNode(_component_el_table_column, {
            prop: "shopId",
            label: "商城编号"
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleUpdate(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['tenantShopUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['tenantShopDelete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper",
          style: {
            "margin-top": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(addClinicShopDialog), {
        modelValue: addVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => addVisible.value = $event),
        model: current.value,
        onRefreshData: getData,
        onClearModel: clearCurrent
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};